import script from "./DepthTasksElement.vue?vue&type=script&setup=true&lang=js"
export * from "./DepthTasksElement.vue?vue&type=script&setup=true&lang=js"

import "./DepthTasksElement.vue?vue&type=style&index=0&id=6b74607a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b74607a"]])

export default __exports__